import { Navigate, useNavigate, useSearchParams } from 'react-router-dom';
import { ApiError } from '../api/client.js';
import { useMagicLinkPreview, useVerifyMagicLink } from '../auth/useSession.js';

/**
 * The page the emailed link lands on. The magic-link token is redeemed only when the person clicks
 * the button below — not by the link's own GET — so mail security scanners (Microsoft Safe Links and
 * the like) that pre-fetch the URL cannot spend the single-use token before the recipient arrives.
 */
export function SigningInPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const verify = useVerifyMagicLink();
  const token = searchParams.get('token');
  const preview = useMagicLinkPreview(token);

  // No token means the link was malformed or the page was opened directly — send them to request one.
  if (!token) return <Navigate to="/login?error=invalid_link" replace />;

  return (
    <main>
      <h1>Voice to Value</h1>
      {preview.data?.surveyTitle && <h2>{preview.data.surveyTitle}</h2>}
      <button
        type="button"
        disabled={verify.isPending}
        onClick={() =>
          verify.mutate(
            { token },
            {
              // A full navigation, so the app reloads with the new session cookie in place.
              onSuccess: ({ redirectTo }) => window.location.assign(redirectTo),
              onError: (error) => {
                const reason =
                  error instanceof ApiError && error.reason ? error.reason : 'expired_link';
                navigate(`/login?error=${reason}`, { replace: true });
              },
            },
          )
        }
      >
        {verify.isPending ? 'Opening your survey…' : 'Click here to continue to the survey'}
      </button>
    </main>
  );
}
